export function sanitizeUrl(path: string, locale: string): string {
  return path
    .replace(/[a-z]+\/[cp|]\//gi, '')
    .replace(new RegExp(`/${locale}`, 'gi'), '');
}
